"use client";

import React, { useCallback } from "react";
import { MODAL_IDS, useGlobalModalStack } from "@wtc/ui";
import { cn } from "@/lib/utils";
import {
  buildComposeModalDataFromContext,
  buildSendTextModalDataFromContext,
  type ContactMethodEntityContext,
} from "@/lib/utils/crm/contact-method-context";

const linkClassName =
  "min-w-0 truncate text-blue-600 hover:text-blue-700 hover:underline transition-colors dark:text-blue-400";

export interface ContactMethodActionsProps {
  kind: "email" | "phone";
  value: string;
  entityContext?: ContactMethodEntityContext;
  className?: string;
}

export function ContactMethodActions({
  kind,
  value,
  entityContext,
  className,
}: ContactMethodActionsProps) {
  const { openModal } = useGlobalModalStack();

  const stop = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  const openCompose = useCallback(
    (event: React.MouseEvent) => {
      stop(event);
      openModal(
        MODAL_IDS.messages.compose,
        buildComposeModalDataFromContext(value, entityContext)
      );
    },
    [entityContext, openModal, stop, value]
  );

  const openTextModal = useCallback(
    (event: React.MouseEvent) => {
      stop(event);
      openModal(
        MODAL_IDS.messages.sendText,
        buildSendTextModalDataFromContext(value, entityContext)
      );
    },
    [entityContext, openModal, stop, value]
  );

  if (kind === "email") {
    return (
      <button
        type="button"
        onClick={openCompose}
        className={cn(linkClassName, "text-left", className)}
        title="Compose email in Hub"
      >
        {value}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={openTextModal}
      className={cn(linkClassName, "text-left", className)}
      title="Send text message in Hub"
    >
      {value}
    </button>
  );
}
